import { __decorate } from "tslib";
import { Component, Vue } from 'vue-property-decorator';
import { defaultSettingData, getSettingById } from '@/api/settings';
import Inr from '@/components/Inr/index.vue';
import HelpText from '@/components/HelpText/index.vue';
let default_1 = class extends Vue {
  constructor() {
    super(...arguments);
    this.data = defaultSettingData;
    this.listLoading = true;
  }
  activated() {
    this.getSetting();
  }
  async getSetting() {
    try {
      this.listLoading = true;
      const data = await getSettingById(1);
      this.data = data;
      this.listLoading = false;
    } catch (error) {
      this.listLoading = false;
    }
  }
};
default_1 = __decorate([Component({
  name: 'SettingsInfo',
  components: {
    Inr,
    HelpText
  }
})], default_1);
export default default_1;